export default __webpack_public_path__ + "static/media/gnb_myheding_m_small.ab462f56.png";